// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__fN3kI","Active":"MenuItem_Active__2yxUC","active":"MenuItem_active__1ly0R"};